/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */

/* eslint-disable no-console */
console.log("Hello World! (from sd-viblock-sd-featured-product block)");
/* eslint-enable no-console */
(function () {
	'use strict';

	// Initialize all sliders on the page
	function initSliders() {
		const sliders = document.querySelectorAll('.featured-products-block');

		sliders.forEach(slider => {
			new FeaturedProductsSlider(slider);
		});
	}

	// Slider Constructor
	function FeaturedProductsSlider(element) {
		this.slider = element;
		this.track = element.querySelector('.featured-products-track');
		this.slides = element.querySelectorAll('.featured-product-slide');
		this.currentIndex = 0;
		this.totalSlides = this.slides.length;

		// Navigation buttons
		this.prevButtons = element.querySelectorAll('.nav-prev');
		this.nextButtons = element.querySelectorAll('.nav-next');

		this.init();
	}

	FeaturedProductsSlider.prototype.init = function () {
		if (this.totalSlides <= 1) {
			this.hideNavigation();
			return;
		}

		this.bindEvents();
		this.updateNavigation();
	};

	FeaturedProductsSlider.prototype.bindEvents = function () {
		const self = this;

		// Previous buttons
		this.prevButtons.forEach(btn => {
			btn.addEventListener('click', () => self.goToPrevious());
		});

		// Next buttons
		this.nextButtons.forEach(btn => {
			btn.addEventListener('click', () => self.goToNext());
		});

		// Keyboard navigation
		this.slider.addEventListener('keydown', (e) => {
			if (e.key === 'ArrowLeft') {
				self.goToPrevious();
			} else if (e.key === 'ArrowRight') {
				self.goToNext();
			}
		});

		// Touch/swipe support
		let touchStartX = 0;
		let touchEndX = 0;

		this.slider.addEventListener('touchstart', (e) => {
			touchStartX = e.changedTouches[0].screenX;
		}, { passive: true });

		this.slider.addEventListener('touchend', (e) => {
			touchEndX = e.changedTouches[0].screenX;
			self.handleSwipe(touchStartX, touchEndX);
		}, { passive: true });
	};

	FeaturedProductsSlider.prototype.goToSlide = function (index) {
		if (index < 0 || index >= this.totalSlides) {
			return;
		}

		this.currentIndex = index;
		const offset = -100 * this.currentIndex;
		this.track.style.transform = `translateX(${offset}%)`;
		this.updateNavigation();
	};

	FeaturedProductsSlider.prototype.goToNext = function () {
		if (this.currentIndex < this.totalSlides - 1) {
			this.goToSlide(this.currentIndex + 1);
		}
	};

	FeaturedProductsSlider.prototype.goToPrevious = function () {
		if (this.currentIndex > 0) {
			this.goToSlide(this.currentIndex - 1);
		}
	};

	FeaturedProductsSlider.prototype.updateNavigation = function () {
		// Disable/enable previous buttons
		this.prevButtons.forEach(btn => {
			btn.disabled = this.currentIndex === 0;
		});

		// Disable/enable next buttons
		this.nextButtons.forEach(btn => {
			btn.disabled = this.currentIndex === this.totalSlides - 1;
		});
	};

	FeaturedProductsSlider.prototype.hideNavigation = function () {
		this.prevButtons.forEach(btn => btn.style.display = 'none');
		this.nextButtons.forEach(btn => btn.style.display = 'none');
	};

	FeaturedProductsSlider.prototype.handleSwipe = function (startX, endX) {
		const swipeThreshold = 50;
		const diff = startX - endX;

		if (Math.abs(diff) > swipeThreshold) {
			if (diff > 0) {
				// Swiped left - go to next
				this.goToNext();
			} else {
				// Swiped right - go to previous
				this.goToPrevious();
			}
		}
	};

	// Initialize when DOM is ready
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSliders);
	} else {
		initSliders();
	}

})();
